<template>
  <div id="__nuxt" style="height: auto !important">
    <!--[-->
    <div class="pc video-name-id-episode___en" data-v-79cdd511="" style="height: auto !important">
      <HeadTop></HeadTop>
      <div class="n-config-provider" style="height: auto !important">
        <div class="page-a" style="height: auto !important">
          <div class="play pc_container" data-v-83ae33d0="" style="height: auto !important">
            <div class="video_breadcrumb" data-v-83ae33d0="" data-v-87454007="">
              <a href="/" class="home_link" data-v-87454007="">Home</a>
              <span class="split" data-v-87454007="">/</span>
              <h2 class="title_dir" data-v-87454007="">
                <a data-v-87454007="">{{ video.title }}</a>
              </h2>
              <!--]--><span class="split" data-v-87454007="">/</span>
              <h2 class="title_dir" data-v-87454007="">{{ current.title }}</h2>
            </div>
            <!---->
            <div class="video_wrap" data-v-83ae33d0="">
              <div class="video_inner" data-v-83ae33d0="">
                <div style="position: relative; display: flex; overflow: hidden">
                  <!-- 视频播放器 muted-->
                  <video autoplay controls controlslist="nodownload noplaybackrate" disablePictureInPicture class="" ref="video" @play="onPlay()" @pause="onPause()" :poster="video.img" width="1200" :src="current.url" style="background: #000">
                    <!-- <source :src="current.url" type="video/mp4" /> -->
                    <source :src="current.url" type="application/x-mpegURL" />
                  </video>

                  <!-- 需要解锁的弹框 -->
                  <div class="tk1box" :class="{ tbup: showUnlock }">
                    <div></div>
                    <div class="xkg1t">
                      <lock-outlined />
                      <div>{{ $t('_sp._xyjscl') }}</div>
                    </div>
                    <div class="tb2bx">
                      <div class="jbdx"><img src="@/static/jinb.png" /></div>
                      <div class="jbdys">{{ wallet.video }}</div>
                      <div>
                        <router-link :to="{ name: 'transfer' }">{{ $t('_sp._cz') }}>></router-link>
                      </div>
                    </div>
                    <div class="tb33x">
                      <div class="tbx3c tbx31a tby1" @click="onUnlockAll()">
                        <div class="tbxd31">
                          <div>$</div>
                          <div>{{ video.total_amount }}</div>
                        </div>
                        <div>{{ $t('_sp._jsqj') }}({{ video.video_total - video.u_unlock_num }})</div>
                      </div>
                      <div class="tbx3c tbx31b tby1" @click="onUnlockOne()">
                        <div class="tbxd31">
                          <div>$</div>
                          <div>{{ video.unit_price }}</div>
                        </div>
                        <div>{{ $t('_sp._jsbj') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="episode" data-v-83ae33d0="" data-v-2cf4d31a="">
                  <h1 class="name" data-v-2cf4d31a="">{{ video.title }}</h1>
                  <ul class="list" data-v-2cf4d31a="">
                    <!--[-->
                    <li @click="setCurrent(i)" :class="{ active: selectIndex == i, lock: item.is_vip == 2 && item.u_vip == 0 }" data-v-2cf4d31a="" v-for="(item, i) in videoList" :key="i">{{ item.sort + 1 }}</li>
                  </ul>
                </div>

                <!---->
              </div>
            </div>
            <div class="content-wrapper" data-v-83ae33d0="" style="height: auto !important">
              <div class="content" data-v-83ae33d0="" style="height: auto !important">
                <!---->
                <h2 class="name" data-v-83ae33d0="">{{ video.title }} - {{ current.title }}</h2>
                <div class="desc_wrap showMore" data-v-83ae33d0="">
                  <h3 class="desc" data-v-83ae33d0="">{{ video.content }}</h3>
                  <!-- <span class="more" data-v-83ae33d0="">More</span> -->
                </div>
                <ul class="tag" data-v-83ae33d0="">
                  <!--[--><!--[-->
                  <!-- <h3 class="link_item" data-v-83ae33d0="">
                    <a href="/genres/Hidden-Identity" data-v-83ae33d0="">Hidden Identity</a>
                  </h3> -->
                  <!--]--><!--]-->
                </ul>
                <!-- <div class="bottom_wrap" data-v-83ae33d0="">
                  <div class="follow" data-v-83ae33d0="">
                    <span class="label" data-v-83ae33d0="">{{ $t('_sp._sc') }}:</span>
                    <div :class="{ active: current.u_collect == 2 }" class="number" data-v-83ae33d0="" @click.stop="addCollect()">{{ $common.formatK(current.collect) }}</div>
                  </div>
                  <div data-v-83ae33d0="" class="share">
                    <span data-v-83ae33d0="" class="label">{{ $t('_sp._fx') }}:</span>
                    <ul data-v-83ae33d0="">
                      <li data-v-83ae33d0="" class="playShareBtn">Link</li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </div>
            <!---->
          </div>
        </div>
      </div>
      <!--]--><!---->
    </div>
    <!----><!----><!---->
    <!-- <div class="loading isPc" style="display: none" data-v-b4f76b67="">
      <img src="../static/img/loading.Czr7mSn8.png" style="" data-v-b4f76b67="" />
    </div>
    <div data-v-4a14e8e9="" class="toast isPc" style="display: none">
      <div data-v-4a14e8e9="" class="toast_wrap">
        <img
          data-v-4a14e8e9=""
          src="data:image/png;base64,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"
          class="icon"
        />
        <div data-v-4a14e8e9="" class="msg_content_wrapper"><span data-v-4a14e8e9="" class="msg_content"></span></div>
      </div>
    </div> -->
    <!--]-->

    <toast ref="payToast" :title="toast.title" :desc="toast.desc" :okText="$t('_sp._qrzf')" :cancel-text="$t('_sp._qx')" :ok="onUnlockOk" :cancel="onUnlockCancel"></toast>
  </div>
</template>

<script>
import { LockOutlined } from '@ant-design/icons-vue'
import HeadTop from '@/components/base/head.vue'
import Toast from '@/components/toast/toast.vue'
export default {
  name: 'videoVue',
  components: {
    HeadTop,
    LockOutlined,
    Toast
  },
  data() {
    return {
      code: '',
      wallet: {},
      video: {},
      videoList: [],
      current: {},
      selectIndex: 0,

      // 解锁弹框
      showUnlock: false,
      //弹框信息
      toast: {
        type: 0,
        title: this.$t('_sp._jsqj'),
        desc: this.$t('_sp._jsqjjs', { a: 0 })
      }
    }
  },
  created() {
    console.log('query', this.$route.query)
    let code = this.$route.query.code
    if (code) {
      this.code = code
    }
    this.getUserState()
    this.getVideo()
    this.$nextTick(() => {
      this.getVideoItemList(0)
    })
  },
  methods: {
    onPlay() {
      console.log('播放开始')
    },
    onPause() {
      console.log('暂停播放')
    },
    //----------------------------------
    getUserState() {
      let that = this
      //获取登录状态
      this.isLogin = this.$common.isLogin()
      if (this.isLogin) {
        this.$api.userWallet.getWallet().then((res) => {
          that.wallet = res.data
        })
      }
    },
    getVideo() {
      let that = this
      this.$api.video
        .getVideo({
          code: Number(this.code)
        })
        .then((res) => {
          that.video = res.data
        })
    },
    getVideoItemList(i) {
      let that = this
      this.$api.video
        .getVideoItemList({
          code: Number(this.code)
        })
        .then((res) => {
          that.videoList = res.data

          //设置默认
          that.setCurrent(i)
        })
    },
    setCurrent(i) {
      this.selectIndex = i
      this.showUnlock = false
      this.current = this.videoList[i]
      if (this.current.is_vip == 2 && this.current.u_vip != 2) {
        console.log('需要开通vip或者解锁才能查看')
        this.onUnlockToast()
        return
      }
      console.log('current', this.current)
    },
    onUnlockToast() {
      this.showUnlock = true
    },
    //解锁全剧
    onUnlockAll() {
      if (this.isLogin) {
        this.toast = {
          type: 1,
          title: this.$t('_sp._jsqj'),
          desc: this.$t('_sp._jsqjjs', { a: this.video.total_amount })
        }
        this.$refs.payToast.open()
      } else {
        this.onUnSignin()
      }
    },
    //解锁单个剧
    onUnlockOne() {
      if (this.isLogin) {
        this.toast = {
          type: 2,
          title: this.$t('_sp._jsbj'),
          desc: this.$t('_sp._jsbjjs', { a: this.video.unit_price })
        }
        this.$refs.payToast.open()
      } else {
        this.onUnSignin()
      }
    },
    onUnlockOk() {
      let that = this
      this.$message.loading({ content: this.$t('_sp._zfz'), key: 'msg' })
      if (this.toast.type == 1) {
        this.$api.userWallet
          .payUnlockAll({
            code: this.video.code
          })
          .then((res) => {
            if (res.code == 1) {
              that.$message.warning({ content: res.msg, key: 'msg' })
              return
            }
            that.$message.success({ content: res.msg, key: 'msg' })
          })
      } else if (this.toast.type == 2) {
        this.$api.userWallet
          .payUnlockOne({
            code: this.current.code
          })
          .then((res) => {
            if (res.code == 1) {
              if (res.msg == 'code required') {
                that.$message.warning({ content: that.$t('_sp._cuow'), key: 'msg' })
                return
              }
              that.$message.warning({ content: res.msg, key: 'msg' })
              return
            }
            that.$message.success({ content: res.msg, key: 'msg' })
          })
          .catch(() => {
            // that.$message.error({ content: err.message, key: 'msg' })
          })
      }

      this.getVideoItemList(this.selectIndex)
      setTimeout(() => {
        this.getUserState()
      }, 1000)
      this.$refs.payToast.close()
    },
    onUnlockCancel() {
      this.$refs.payToast.close()
    },
    //点收藏
    addCollect() {
      let that = this
      let id = this.current.id
      let i = this.selectIndex
      this.$api.video
        .addCollect({
          vi_id: id
        })
        .then((res) => {
          if (res.code == 1) {
            that.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          that.videoList[i].u_collect = res.data.u_collect
          if (res.data.u_collect == 2) {
            that.videoList[i].collect = parseInt(that.videoList[i].collect) + 1
          } else {
            that.videoList[i].collect = parseInt(that.videoList[i].collect) - 1
          }
        })
    }
  }
}
</script>

<style scoped>
@import url('../static/css_video/episodes-1.css');
@import url('../static/css_video/index.COVLesWc.css');
</style>
<style>
.tk1box {
  height: 150px;
  position: absolute;
  bottom: -150px;
  width: 100%;
  background: var(--video-pay-bg-color);
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px 20px 0 0;
  gap: 10px;
  transition: all 0.3s;
}
.tbup {
  bottom: 0;
}

.tb2bx {
  display: flex;
  gap: 10px;
  align-items: center;
}

.tb2bx a {
  color: var(--text-color);
}

.tb33x {
  display: flex;
  gap: 20px;
}

.tbx3c {
  flex: 1;
}

.tbxd31 {
  display: flex;
}

.tbx31a {
  height: 50px;
  background-color: #ff5722;
  /* border: 2px solid #ffd17d; */
  color: #fff;
}

.tbx31b {
  background: linear-gradient(135deg, #0f6b5f, #0a4f46);
  color: #fff;
}

.tby1 {
  cursor: pointer;
  border-radius: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.xkg1t {
  display: flex;
  gap: 5px;
  color: #7e7e7e;
}

.jbdx {
  width: 20px;
  height: 20px;
}
.jbdx img {
  width: 100%;
  height: 100%;
}

.jbdys {
  color: #ff9800;
  font-size: 16px;
}
</style>
